/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import { differenceInDays } from "date-fns/differenceInDays";

import { spacing } from "../../../../../../global/emotion";
import { useCountdown } from "../../../../../hooks/useCountdown";
import { Card, type CardProps } from "../../../../refactor/Card/Card.emotion";

const cardStyle: Interpolation = {
  paddingBottom: "96px",
  paddingTop: `calc(${spacing.full} - ${spacing.xs})`,
};
const infoContainerStyle: Interpolation = {
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};
const maskStyle: Interpolation = {
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
};

export type ChallengeMediumProps = CardProps & {
  availableAt?: string;
  endsAt?: string;
};

export const ChallengeMedium = ({
  centerActions,
  availableAt,
  description,
  endsAt,
  imgSrc,
  infoContainerCSS,
  maskProps,
  tags = [],
  title,
  ...props
}: ChallengeMediumProps) => {
  const t = useTranslations();

  const countdown = useCountdown({
    targetDate: availableAt,
    format: "default",
  });
  let dateTag: null | string = null;

  if (availableAt && endsAt) {
    const date = new Date();
    const ended = date > new Date(endsAt);
    const started = date > new Date(availableAt);

    dateTag = ended
      ? t("challenge_tile_event_over")
      : started
        ? t("challenge_tile_days_left_label", {
            challenge_tile_days_left_label: differenceInDays(
              new Date(endsAt),
              date,
            ),
          })
        : t("challenge_tile_starts_in", {
            0: countdown,
          });
  }

  return (
    <Card
      description={description}
      imgSrc={imgSrc}
      infoContainerCSS={[infoContainerStyle, infoContainerCSS]}
      maskCSS={maskStyle}
      maskProps={maskProps}
      css={cardStyle}
      centerActions={centerActions}
      tags={dateTag ? [...tags, dateTag] : tags}
      title={title}
      {...props}
    />
  );
};
